import './AppFooter.scss';
import { useLocation } from 'react-router-dom';
import { useAdobeAnalytics } from '../../providers/AdobeAnalytics';
import { useCallback, useEffect, useState } from 'react';
import { useSkipLink } from '../../providers/SkipLinkProvider';
import acLogo from '../../assets/images/ac_logo-reversed.svg';
import IATALogo from '../../assets/images/IATA-logo.png';
import starLogo from '../../assets/images/ac_star.svg';
import starLogoFr from '../../assets/images/ac_star_fr_rgb_hor.svg';
import useWindowSize from '../../assets/customHooks/useWindowSize';
import { useDispatch } from 'react-redux';
import { resetAllReleaseItems } from '../../redux/slices/staticPagesSlice';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const currentYear = new Date().getFullYear();
const AppFooterBottomText = `© ${currentYear} Air Canada`;
let AppFooterTopData: any = [];
let selectedLang = '';
interface AppFooterProps {
  isFooterNavigation?: boolean;
  setIsFooterNavigation?: (value: boolean) => void;
  isStatusAPILoading?: boolean;
}

const AppFooter = ({
  isFooterNavigation,
  setIsFooterNavigation,
  isStatusAPILoading
}: AppFooterProps) => {
  const { t, i18n } = useTranslation();
  selectedLang = i18n.language;

  const location = useLocation();
  const { width } = useWindowSize();

  const isSubseller = !location.pathname.toLowerCase().includes('subseller');
  const isBackOffice = !location.pathname.toLowerCase().includes('backoffice');

  const data = t('navigation', { returnObjects: true });
  const getFooterData = useCallback(() => {
    if (!data) return;

    const nav = data;
    const footerItems = [
      Array.isArray(nav) ? nav.filter((x) => x.link.menu_name === 'footer') : []
    ];

    footerItems[0]?.forEach((itm) => {
      let linksArr: any = [];

      if (itm?.link?.hasOwnProperty('map_to_menu')) {
        //This footer menu is same as what's in mainnav, so map it/use main nav content
        const mappedNav = Array.isArray(nav)
          ? nav.filter((x) => x.link.menu_name === itm.link.map_to_menu)
          : [];
        mappedNav.forEach((map) => {
          if (
            map.link?.children_name !== 'support' &&
            map.link?.children_name !== 'api_info'
          ) {
            //Support and API Info from main nav are there own nav columns, so ignore here...
            linksArr[map.link.weight - 1] = {
              title: map.link.title,
              link: map.link.url
            };
          }
        });
      } else {
        //This footer menu is unique (not in main nav as well)
        itm.link.subtree.forEach(
          (map) =>
            (linksArr[map.link.weight - 1] = {
              title: map.link.title,
              link: map.link.url
            })
        );
      }

      AppFooterTopData[itm?.link?.weight - 1] = {
        mainTitle: itm?.link?.title,
        links: linksArr
      };
    });
  }, [data]);

  useEffect(() => {
    getFooterData();
  }, [getFooterData]);

  return (
    <footer className="footer">
      {width! > 940 ? (
        <>
          <FooterLogos width={width} />
          {isSubseller && isBackOffice && (
            <FooterLinks
              width={width}
              setIsFooterNavigation={setIsFooterNavigation}
              isStatusAPILoading={isStatusAPILoading}
            />
          )}
        </>
      ) : (
        <>
          {isSubseller && isBackOffice && (
            <FooterLinks
              width={width}
              setIsFooterNavigation={setIsFooterNavigation}
              isStatusAPILoading={isStatusAPILoading}
            />
          )}
          <FooterLogos width={width} />
        </>
      )}
      <div className="footerBottom">
        {width! < 768 && <div></div>}
        <span>{AppFooterBottomText}</span>
      </div>
    </footer>
  );
};

// const FooterLinks = ({ width }) => {
//   const { adobeAnalyticsSectionClick, adobeSiteInteraction } =
//     useAdobeAnalytics();
//   const { setSkipLinks } = useSkipLink() as any;
//   const desktop = width > 1200;

//   const dispatch = useDispatch()

//   const skipLinkRef = useCallback(
//     (node) => {
//       if (node !== null) {
//         setSkipLinks((prev) => {
//           const index = prev.findIndex((item) => item.id === 3);
//           return [
//             ...prev.slice(0, index),
//             { ...prev[index], ref: node },
//             ...prev.slice(index + 1)
//           ];
//         });
//       }
//     },
//     [setSkipLinks]
//   );

//   return (
//     <div className="footerLinkSection">
//       <div className="footerLinkSectionInnerContainer">
//         {AppFooterTopData.map((data, index) => {
//           let linkSectionStyle = {} as React.CSSProperties;
//           if (index !== 0) {
//             linkSectionStyle['--padding'] = desktop
//               ? selectedLang !== 'fr'
//                 ? '40px'
//                 : '20px'
//               : '0px';
//           }
//           if (selectedLang === 'fr' && !desktop) {
//             linkSectionStyle['minWidth'] =
//               width < 768 ? '150px' : width < 1200 ? '220px' : '200px';
//           }

//           return (
//             <div
//               key={`${index}-top-heading`}
//               className="linkSection"
//               style={linkSectionStyle}
//             >
//               <div className="linkSectionContainer">
//                 <p
//                   style={{
//                     color: '#E3E3E3',
//                     fontSize: '1.17em',
//                     fontWeight: '700'
//                   }}
//                 >
//                   {data.mainTitle.toUpperCase()}
//                 </p>
//               </div>
//               <ul>
//                 {data.links.map((link, i) => (
//                   <li
//                     key={`${i}-bottom-link`}
//                     onClick={(e) => {
//                       if (link.link.includes('releasenotes')) {
//                         dispatch(resetAllReleaseItems());
//                       }
//                       adobeAnalyticsSectionClick('footer nav');
//                       (link.title === 'Sandbox' ||
//                         link.title === 'Bac à sable') &&
//                         adobeSiteInteraction('sandbox-footer');
//                         window.scrollTo({top: 0, behavior: 'smooth' });
//                     }}
//                   >
//                     {link.link.charAt(0) !== '/' ? (
//                       <a href={link.link} target="_blank" rel="noreferrer">
//                         {link.title}
//                       </a>
//                     ) : (
//                       <Link
//                         to={`/${selectedLang}${link.link}`}
//                         {...(link.title === 'Benefits' && { ref: skipLinkRef })}
//                       >
//                         {link.title}
//                       </Link>
//                     )}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

const FooterLinks = ({ width, setIsFooterNavigation, isStatusAPILoading }) => {
  const { adobeAnalyticsSectionClick, adobeSiteInteraction } =
    useAdobeAnalytics();
  const { t } = useTranslation();
  const [isStatusMonitoring, setIsStatusMonitoring] = useState(false);

  useEffect(() => {
    if (!isStatusAPILoading && isStatusMonitoring) {
      const firstHeading = document.querySelector('h1') as HTMLElement;
      const headerStatusMonitoring = t(
        'support.status-monitoring.section.header.title'
      ) as unknown as string;
      const firstHeaderContent = firstHeading.textContent || '';
      const isStatusMonitoringPage = firstHeaderContent.includes(
        headerStatusMonitoring
      );

      if (isStatusMonitoringPage) {
        setTimeout(() => {
          firstHeading.setAttribute('tabindex', '-1');
          firstHeading.focus();
          setIsStatusMonitoring(false);
        }, 50);
      }
    }
    // eslint-disable-next-line
  }, [isStatusAPILoading, isStatusMonitoring]);

  // Ensure Manage Cookies button is injected in the correct footer section
  useEffect(() => {
    const injectManageCookiesButton = () => {
      try {
        // Check if button already exists
        const existingButton = document.querySelector('#OneTrustPrefCenter');
        if (existingButton) return;

        const footer = document.querySelector('footer');
        if (!footer) return;

        const linkSections = footer.querySelectorAll('.linkSection');
        // Target the last linkSection which should be under Support
        const legalSection = linkSections[linkSections.length - 2];

        if (!legalSection) return;

        const ul = legalSection.querySelector('ul');
        const lastLi = ul?.querySelector('li:last-child');

        if (!ul || !lastLi) return;

        // Clone the last li element
        const cloneDiv = lastLi.cloneNode(true) as HTMLElement;
        const link = cloneDiv.querySelector('a, button');

        if (!link) return;

        // Get the translation for Manage Cookies
        const txtPref =
          selectedLang === 'fr' ? 'Gérer Les Cookies' : 'Manage Cookies';

        // Configure the cloned element
        link.removeAttribute('href');
        link.removeAttribute('target');
        link.setAttribute('id', 'OneTrustPrefCenter');
        link.textContent = txtPref;

        // Add onclick handler to open OneTrust preferences
        (link as HTMLElement).onclick = function (e) {
          e.preventDefault();
          if (typeof (window as any).OneTrust !== 'undefined') {
            (window as any).OneTrust.ToggleInfoDisplay();
          }
        };

        // Make it look like a button/link
        (link as HTMLElement).style.cursor = 'pointer';

        // Append to the ul
        ul.appendChild(cloneDiv);
      } catch (error) {
        console.warn('Failed to inject Manage Cookies button:', error);
      }
    };

    // Run after a slight delay to ensure footer is rendered
    const timer = setTimeout(injectManageCookiesButton, 500);

    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [AppFooterTopData]);

  const { setSkipLinks } = useSkipLink() as any;

  const navigate = useNavigate();

  const desktop = width > 1200;

  const dispatch = useDispatch();

  const handleInternalLinkClick = (
    link: any,

    linkTitle: string,

    e: React.MouseEvent,
    t: React.FunctionComponent
  ) => {
    e.preventDefault();

    if (link.link.includes('releasenotes')) {
      dispatch(resetAllReleaseItems());
    }

    adobeAnalyticsSectionClick('footer nav');

    (linkTitle === 'Sandbox' || linkTitle === 'Bac à sable') &&
      adobeSiteInteraction('sandbox-footer');

    // Navigate programmatically
    setIsFooterNavigation(true);

    navigate(`/${selectedLang}${link.link}`);

    // Focus management after navigation

    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });

      // Try to focus on first heading, skip link, or first interactive element

      const firstHeading = document.querySelector('h1') as HTMLElement;
      const headerStatusMonitoring = t(
        'support.status-monitoring.section.header.title'
      ) as unknown as string;
      const firstHeaderContent = firstHeading.textContent || '';
      const isStatusMonitoringPage = firstHeaderContent.includes(
        headerStatusMonitoring
      );

      // const skipLink = document.querySelector(
      //   'a[href="#main-content"]'
      // ) as HTMLElement;

      const mainContent = document.querySelector(
        'main, #main-content, [role="main"]'
      ) as HTMLElement;

      const firstFocusable = document.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      ) as HTMLElement;

      if (firstHeading) {
        if (!isStatusMonitoringPage) {
          firstHeading.setAttribute('tabindex', '-1');
          firstHeading.focus();
        } else {
          setIsStatusMonitoring(true);
        }
      } else if (mainContent) {
        mainContent.setAttribute('tabindex', '-1');
        mainContent.focus();
      } else if (firstFocusable) {
        firstFocusable.focus();
      }
    }, 200);

    setTimeout(() => {
      setIsFooterNavigation(false);
    }, 500);
  };

  const skipLinkRef = useCallback(
    (node) => {
      if (node !== null) {
        setSkipLinks((prev) => {
          const index = prev.findIndex((item) => item.id === 3);

          return [
            ...prev.slice(0, index),

            { ...prev[index], ref: node },

            ...prev.slice(index + 1)
          ];
        });
      }
    },

    [setSkipLinks]
  );

  return (
    <div className="footerLinkSection">
      <div className="footerLinkSectionInnerContainer">
        {AppFooterTopData.map((data, index) => {
          let linkSectionStyle = {} as React.CSSProperties;

          if (index !== 0) {
            linkSectionStyle['--padding'] = desktop
              ? selectedLang !== 'fr'
                ? '40px'
                : '20px'
              : '0px';
          }

          if (selectedLang === 'fr' && !desktop) {
            linkSectionStyle['minWidth'] =
              width < 768 ? '150px' : width < 1200 ? '220px' : '200px';
          }

          return (
            <div
              key={`${index}-top-heading`}
              className="linkSection"
              style={linkSectionStyle}
            >
              <nav aria-label={`${data.mainTitle} navigation`}>
                <div className="linkSectionContainer">
                  <h3
                    style={{
                      color: '#E3E3E3',

                      fontSize: '1.17em',
                      marginTop: '16.38px',
                      fontWeight: '700'
                    }}
                  >
                    {data.mainTitle}
                  </h3>
                </div>
                <ul>
                  {data.links.map((link, i) => (
                    <li key={`${i}-bottom-link`}>
                      {link.link.charAt(0) !== '/' ? (
                        <a
                          href={link.link}
                          target="_blank"
                          rel="noreferrer"
                          onClick={() => {
                            adobeAnalyticsSectionClick('footer nav');

                            (link.title === 'Sandbox' ||
                              link.title === 'Bac à sable') &&
                              adobeSiteInteraction('sandbox-footer');
                          }}
                        >
                          {link.title}
                        </a>
                      ) : (
                        <button
                          type="button"
                          className="footer-link-button"
                          onClick={(e) =>
                            handleInternalLinkClick(link, link.title, e, t)
                          }
                          {...(link.title === 'Benefits' && {
                            ref: skipLinkRef
                          })}
                        >
                          {link.title}
                        </button>
                      )}
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const FooterLogos = ({ width }) => {
  const dividerStyle = {
    height: '40px',
    borderRight: '1px solid #fff',
    margin: '0 10px'
  };

  const skytraxLogoSrc =
    'https://kilo-content.aircanada.com/ac/applications/achomebeta/content/1.0.1021/assets/img/logos/skytrax/4-starts-skytrax-en.svg';
  const skytraxLogoFrSrc =
    'https://kilo-content.aircanada.com/ac/applications/achomebeta/content/1.0.1021/assets/img/logos/skytrax/4-starts-skytrax-fr.svg';

  return (
    <div className="footerLogos">
      <div className="footerLogoContainer">
        <div className="leftContainer">
          <img
            src={IATALogo}
            alt="IATA"
            aria-label="Air Canada is a member of IATA, the International Air Transport Association"
            style={{ width: '86px' }}
          />
          <img
            src={selectedLang === 'fr' ? skytraxLogoFrSrc : skytraxLogoSrc}
            alt="Skytrax"
            aria-label="The only Four-Star international network carrier in North America"
            className="skytrax"
          />
          {width > 940 && <span style={dividerStyle}></span>}
          <span className={`text ${selectedLang === 'fr' ? 'fr' : ''}`}>
            {selectedLang === 'fr'
              ? 'Le seul transporteur exploitant un réseau international quatre étoiles en Amérique du Nord'
              : 'The only Four-Star international network carrier in North America'}
          </span>
        </div>
        <div className="rightContainer">
          <img
            src={selectedLang === 'fr' ? starLogoFr : starLogo}
            alt="Star Alliance"
            aria-label="Air Canada is a member of Star Alliance"
            className="starLogo "
          />
          {width > 940 && (
            <span style={{ ...dividerStyle, height: '20px' }}></span>
          )}
          <img src={acLogo} alt="Air Canada" aria-hidden="true" />
        </div>
      </div>
    </div>
  );
};

export default AppFooter;
